module.exports = __webpack_public_path__ + "img/PY.e6a6e396.svg";